import React from 'react';
import { ArrowRight, Phone } from 'lucide-react';

const Hero = () => {
  const phoneNumber = '5515991253527';
  const message = encodeURIComponent('Olá! Gostaria de solicitar um orçamento.');
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${message}`;

  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
    >
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src="/assets/images/hero-sacada.jpg"
          alt="Sacada envidraçada moderna - Forti Vidros"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/60 to-black/40"></div>
      </div>

      {/* Content */}
      <div className="container-custom relative z-10 py-32">
        <div className="max-w-3xl">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/10 backdrop-blur-sm border border-white/20 mb-8 fade-in">
            <div className="w-2 h-2 bg-[var(--accent-gold)] rounded-full animate-pulse"></div>
            <span className="text-sm text-white font-medium">
              Mais de 20 anos no mercado
            </span>
          </div>

          {/* Headline */}
          <h1 
            className="hero-large mb-6 fade-in" 
            style={{ 
              animationDelay: '0.2s',
              color: '#ffffff',
              textShadow: '2px 2px 8px rgba(0,0,0,0.9), 0 0 30px rgba(0,0,0,0.7)'
            }}
          >
            Transforme sua sacada em um ambiente elegante e protegido
          </h1>

          {/* Subheadline */}
          <p 
            className="body-large mb-8 fade-in" 
            style={{ 
              animationDelay: '0.4s',
              color: '#ffffff',
              textShadow: '2px 2px 8px rgba(0,0,0,0.9), 0 0 30px rgba(0,0,0,0.7)'
            }}
          >
            Especialistas em envidraçamento de sacadas, boxes de banheiro e soluções em vidro com acabamento premium em Sorocaba
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 fade-in" style={{ animationDelay: '0.6s' }}>
            <a
              href={whatsappUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-gold"
            >
              <Phone size={18} />
              Solicitar Orçamento
            </a>
            <button
              onClick={() => document.getElementById('gallery').scrollIntoView({ behavior: 'smooth' })}
              className="btn-primary bg-white/10 text-white border-white hover:bg-white hover:text-[var(--text-primary)]"
            >
              Ver Projetos
              <ArrowRight size={18} />
            </button>
          </div>

          {/* Trust Indicators */}
          <div className="flex flex-wrap items-center gap-8 mt-12 fade-in" style={{ animationDelay: '0.8s' }}>
            <div className="flex items-center gap-2">
              <div className="flex">
                {[...Array(5)].map((_, i) => (
                  <svg
                    key={i}
                    className="w-5 h-5 text-[var(--accent-gold)]"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                  </svg>
                ))}
              </div>
              <span className="text-white font-medium">4.6 no Google</span>
            </div>
            <div className="h-8 w-px bg-white/30"></div>
            <div className="text-white">
              <p className="font-semibold">40+ Avaliações</p>
              <p className="text-sm text-white/80">Clientes satisfeitos</p>
            </div>
            <div className="h-8 w-px bg-white/30"></div>
            <div className="text-white">
              <p className="font-semibold">Desde 2004</p>
              <p className="text-sm text-white/80">Tradição em Sorocaba</p>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10 animate-bounce">
        <div className="w-6 h-10 border-2 border-white/50 rounded-full flex items-start justify-center p-2">
          <div className="w-1 h-3 bg-white/50 rounded-full"></div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
